import { RecursiveObject } from '@chakra-ui/react'

export const fonts: RecursiveObject<string> = {
  heading: "'Satoshi', sans-serif",
  body: "'Satoshi', sans-serif",
}
